import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContextService {
	private path!: string;

	constructor(
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: ContextService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	public getEnvironement(): Observable<string> {
		let url = this.path + "context/environment";
		
		// On ajoute un header special pour empecher l'intercepteur d'afficher un indicateur de chargement
		let headers = new HttpHeaders().set("no-pending-trace", "true");
		
		// 'text" as 'json' est ici utilise pour contourner un bug
		// voir https://github.com/angular/angular/issues/18672
		return this.httpClient //
				.get<string>(url, { headers: headers, responseType: 'text' as 'json' }) //
		;		
	}
	
	private requestedHash: string | null = null;
	public setRequestedHash(hash: string | null) {
		this.requestedHash = hash;
	}
	public getRequestedHash(): string | null {
		return this.requestedHash;
	}
}